import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { requestHdr as __requestHdr } from '../core/request';
import { requestApiResult as __requestApiResult } from '../core/request';
export class VmcTypeService {
    /**
     * @param pagingHeader
     * @param filter
     * @returns VmcStatusDto Success
     * @throws ApiError
     */
    static async get(token, pagingRange, filter, search) {
        return await __requestApiResult(OpenAPI, {
            method: 'GET',
            url: `/api/VmcTypes`,
            headers: {
                Range: `locations=${pagingRange}`,
                Authorization: `Bearer ${token}`
            },
            query: {
                'filter': filter,
                'search': search
            },
            responseHeader: 'Content-Range'
        });
    }
    /**
     * @param id
     * @returns VmcStatusDto Success
     * @throws ApiError
     */
    static async get1(token, id) {
        return await __request(OpenAPI, {
            method: 'GET',
            url: `/api/VmcTypes/${id}`,
            headers: { Authorization: `Bearer ${token}` }
        });
    }
    static async getTotalCount(token, filter, search) {
        return await __requestHdr(OpenAPI, {
            method: 'GET',
            url: '/api/VmcTypes',
            headers: { Range: 'locations=0-1', Authorization: `Bearer ${token}` },
            query: {
                'filter': filter,
                'search': search
            },
            responseHeader: 'Content-Range'
        });
    }
}
//# sourceMappingURL=VmcTypeService.js.map